if (!customElements.get('product-features-modal')) {
  customElements.define(
    'product-features-modal',
    class ProductFeaturesModal extends ModalWindow {
      constructor() {
        super();
      }

      show(opener) {
        console.log('show product features modal');
        this.opener = opener;
        window.pauseAllMedia();
        this.style.display = 'block';
        this.classList.add('modal-show');

        lazyLoadInstance?.update();

        setTimeout(() => {
          document.body.style.overflow = 'hidden';
          this.classList.add('modal-visuallyshow');
        }, 300);

        // Add focus trapping after the modal is shown
        requestAnimationFrame(() => {
          trapFocus(this);
        });
      }
    }
  );
}
